import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-help-icon',
    templateUrl: './help-icon.component.html',
    styleUrls: ['./help-icon.component.scss']
})
export class HelpIconComponent extends AbstractIcon {
    constructor() {
        super();

        this.height = 24;
        this.width = 24;
    }
}
